import { LoadingSpinner } from '@web_opxp/components';
import { LanguageSelectors } from '@web_opxp/language';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ENV from '../base/env';
import CookieBannerWrapper from '../components/CookieBannerWrapper';
import FaqSection from '../components/faqSection/FaqSection';
import FeedbackSection from '../components/feedbackSection/FeedbackSection';
import FooterWrapper from '../components/footerWrapper/FooterWrapper';
import PremiumGetSection from '../components/premiumGetSection/PremiumGetSection';
import TrustBannerSection from '../components/trustBannerSection/TrustBannerSection';
import Checkout from './Checkout';
import HeaderWrapperConnected from './HeaderWrapperConnected';
import * as Selectors from './selectors';
import { CheckoutActions } from './slice';

export default function CheckoutApp() {
  const dispatch = useDispatch();
  const loading = !useSelector(Selectors.isCheckoutReady);
  useEffect(() => {
    // prevent dispatching the action if app has started already
    if (!loading || !dispatch) {
      return;
    }
    dispatch(CheckoutActions.initCheckout());
  }, [dispatch, loading]);
  const language = useSelector(LanguageSelectors.getLanguage);
  useEffect(() => {
    if (!language) {
      return;
    }
    window.document.documentElement.lang = language;
  }, [language]);
  if (loading) return <LoadingSpinner assetsUrl={ENV.AssetsBaseUrl} />;
  return (
    <div className="App">
      <HeaderWrapperConnected />
      <div className="App-body">
        <Checkout />
        <TrustBannerSection />
        <FeedbackSection hideRegistrationButton />
        <PremiumGetSection />
        <FaqSection />
      </div>
      <FooterWrapper />
      <CookieBannerWrapper language={language} />
    </div>
  );
}
